<ng-container *transloco="let t">
  @if (
    {
      assetListOptions: assetListOptions$ | async,
      assetList: assetList$ | async,
      currencies: currencies$ | async,
      forecastOptions: forecastOptions$ | async,
    };
    as data
  ) {
    @if (data.assetList != null && data.currencies != null) {
      <form [formGroup]="form" class="forecast-options">
        <div class="field">
          <label class="mat-subheading-2 currency-label">{{ t('forecast.currency') }}</label>
          <mat-form-field class="am-form-field currency-field" appearance="fill">
            <mat-select disableRipple="true" hideSingleSelectionIndicator="true" formControlName="currency">
              @for (currency of data.currencies; track currency) {
                <mat-option [value]="currency.label">
                  {{ currency.label }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        <div class="field">
          <label class="mat-subheading-2">{{ t('forecast.hedging') }}</label>
          <mat-button-toggle-group
            class="hedge-field"
            hideSingleSelectionIndicator
            #group="matButtonToggleGroup"
            formControlName="isHedge"
          >
            <mat-button-toggle [value]="false">{{ t('forecast.unhedged') }}</mat-button-toggle>
            <mat-button-toggle [value]="true">{{ t('forecast.hedged') }}</mat-button-toggle>
          </mat-button-toggle-group>
        </div>
        <div class="field">
          <label class="mat-subheading-2">{{ t('forecast.asset-classes') }}</label>
          <am-multiselect-with-search
            [options]="data.assetListOptions"
            formControlName="assetClasses"
          ></am-multiselect-with-search>
        </div>
      </form>
      @if (data.forecastOptions) {
        <div class="graph am-box-shadow" echarts [options]="data.forecastOptions"></div>
      }
    } @else {
      <div class="am-loading">
        <mat-spinner class="am-spinner" [diameter]="70"></mat-spinner>
        {{ t('forecast.loading') }}
      </div>
    }
    <ng-container></ng-container>
  }
</ng-container>
